// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"72da0679","239":"200af016","732":"8dcdafb4"}[chunkId] + ".chunk.js";
};